import { compareJSONObjects } from '../../../../utils';

function checkIfIsUpdate(blockName, userChange, ownerChange) {
  let isUpdate = true;

  if (blockName === 'Services') {
    if (
      userChange.contract_block.accept &&
      !userChange.contract_block.accept2
    ) {
      if (ownerChange.producer === userChange.contract_block.changes.producer) {
        isUpdate = false;
      }
    }
    if (
      !userChange.contract_block.accept &&
      userChange.contract_block.accept2
    ) {
      const ownerDealChanges = { ...ownerChange, producer: null };
      const userChanges = {
        ...userChange.contract_block.changes,
        producer: null,
      };
      if (compareJSONObjects(ownerDealChanges, userChanges)) {
        isUpdate = false;
      }
    }
  } else if (blockName === 'Ownership') {
    if (
      userChange.contract_block.accept &&
      !userChange.contract_block.accept2
    ) {
      if (
        ownerChange.composition ===
        userChange.contract_block.changes.composition
      ) {
        isUpdate = false;
      }
    }
    if (
      !userChange.contract_block.accept &&
      userChange.contract_block.accept2
    ) {
      if (ownerChange.consent === userChange.contract_block.changes.consent) {
        isUpdate = false;
      }
    }
  } else if (blockName === 'Cure; Remedies') {
    if (
      userChange.contract_block.accept &&
      !userChange.contract_block.accept2
    ) {
      if (
        ownerChange.field1 === userChange.contract_block.changes.field1 &&
        ownerChange.field3 === userChange.contract_block.changes.field3
      ) {
        isUpdate = false;
      }
    }
    if (
      !userChange.contract_block.accept &&
      userChange.contract_block.accept2
    ) {
      if (ownerChange.field2 === userChange.contract_block.changes.field2) {
        isUpdate = false;
      }
    }
  } else {
    isUpdate = true;
  }

  return isUpdate;
}

export default checkIfIsUpdate;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/checkIfIsUpdate.js